<template>
  <div>
    <modal 
      class="dialer_animation right_side_popup m-w-600 scrollable bigSquareCheckbox IosModal" 
      width="50%" 
      :scrollable="true" 
      height="auto"  
      :name="modalName" 
      @before-open="onBeforeOpen($event)" 
      @before-close="onBeforeClose()"
    >
      <Numbers :accountcode="data.accountcode" @back="$modal.hide(modalName)" />
    </modal>
  </div>
</template>

<script>
import Numbers from '../admin/Numbers.vue'
export default {
  name: "NumbersSettingModal",
  components: {
    Numbers,
  },
  props: {
    modalName: {
      type: String,
      default: 'NumbersSetting'
    },
  },
  data() {
    return {
      data: {
        accountcode: '',
      },
    };
  },
  methods: {
    onBeforeOpen(event){
      this.data.accountcode=event?.params?.account ?? ''
    },
    onBeforeClose(){
      this.data.accountcode=''
    },
  },
};
</script>

<style lang="scss" scoped>

</style>